import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const orderApi = factory.get("order");

const initialState = {
  orders: {
    data: [],
    loading: false,
    total: 0,
    dialog: false,
    createDialog: false,
    creating: false,
    filters: {
      skip: 0,
      page: 0,
      take: 25,
      search: "",
      order_number: "",
      ftth_task_id: "",
      start_date: null,
      end_date: null,
      status: null,
      type: null,
      item_id: null,
      user_type: null,
      user_id: null,
      action: null,
      is_cleared: null,
    },
  },
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.orders.data = payload.data;
      state.orders.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state.orders.loading = !state.orders.loading;
    },
    setCreating: (state, { payload }) => {
      state.orders.creating = payload;
    },
    setFilters: (state, { payload }) => {
      state.orders.filters = {
        ...state.orders.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.orders.filters = initialState.orders.filters;
    },
    setFiltersDialog: (state) => {
      state.orders.dialog = !state.orders.dialog;
    },
    setCreateDialog: (state) => {
      state.orders.createDialog = !state.orders.createDialog;
    },
  },
});

export const {
  setData,
  setLoading,
  setCreating,
  setFilters,
  resetFilters,
  setFiltersDialog,
  setCreateDialog,
} = ordersSlice.actions;

export default ordersSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading());
    const rawFilters = getState().orders.orders.filters;
    const filters = {
        ...rawFilters,
        item_id: rawFilters.item_id?.id || rawFilters.item_id,
        user_id: rawFilters.user_id?.id || rawFilters.user_id,
    }
    const res = await orderApi.getOrders(filters);
    dispatch(setData(res.data));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.message || "حدث خطأ ما",
      }),
    );
    throw new Error(err);
  }
};

const store = (data) => async (dispatch) => {
  try {
    dispatch(setCreating(true));
    const res = await orderApi.storeOrder(data);
    dispatch(
      showNotification({
        type: "success",
        message: res.data?.message || "تمت إضافة الطلب بنجاح",
      }),
    );
    dispatch(setCreateDialog());
    dispatch(index());
    dispatch(setCreating(false));
  } catch (err) {
    dispatch(setCreating(false));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.message || "حدث خطأ ما",
      }),
    );
    throw new Error(err);
  }
};

export const OrdersAction = {
  index,
  store,
};
